import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import ArrowLeftIcon from 'assets/images/Dashboard/arrow-left.svg';
import checkIcon from 'assets/images/WithoutLogin/Checkbox.svg';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { postPurchase } from 'store/purchaseDoctor/purchaseDoctorAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getSubscription } from 'store/subscriptionPlan/subscriptionPlanAction';
import Shimmer from 'components/commom/Shimmer';
import LocalStorageManager from 'managers/LocalStorageManger';
import CommonToast from 'components/commom/CommonToast';

const DoctorPaymet = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const params = useParams();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [sandboxLink, setSandBoxLink] = useState('');
  const [subscriptionList, setSubscriptionList] = useState([]);

  const loading = useSelector(
    (state) => state?.getSubscriptionReducer?.loading
  );

  const profileData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  useEffect(() => {
    LocalStorageManager.setItem('token', params?.token);
  }, []);

  useEffect(() => {
    subscriptionPlanList(profileData?.title?.slug);
  }, []);

  const getPurchaseData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSandBoxLink(res?.data?.links?.[0]?.href);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      plan_id: params?.value,
      base_url: window.location.origin + '/',
    };
    dispatch(postPurchase(external, body));
  };

  const subscriptionPlanList = (quaryValue) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        const filteredPlans = res?.data
          .map((plan) => ({
            ...plan,
            sub_plans: plan.sub_plans.filter(
              (subPlan) => subPlan.subscription_plan_id === params?.value
            ),
          }))
          .filter((plan) => plan.sub_plans.length > 0);

        setSubscriptionList(filteredPlans);
        getPurchaseData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSubscription(external, quaryValue));
  };

  const ProductDescription = ({ description }) => {
    const stripHtmlTags = (html) => {
      if (!html) return [];
      return html
        .replace(/<[^>]*>/g, '')
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '' && line !== '&nbsp;');
    };

    const lines = stripHtmlTags(description);

    const capitalizeFirstLetter = (line) => {
      if (line.length === 0) return line;
      return line.charAt(0).toUpperCase() + line.slice(1).toLowerCase();
    };

    const highlightKeywords = (text) => {
      const keywords = [
        'Name',
        'Title',
        'Practice location',
        'Listed after advanced in roster',
      ];

      keywords.forEach((keyword) => {
        const regex = new RegExp(`(${keyword})`, 'gi');
        text = text.replace(
          regex,
          '<span style="font-size:14px; font-weight:400;" class="family_outfit_regular_400">$1</span>'
        );
      });

      text = text.replace(/:\s*([^,]*),/g, ': $1');
      return text;
    };

    return (
      <div>
        {lines.map((line, index) =>
          line && line !== '&nbsp;' ? (
            <div key={index} className="flex items-start mb-2">
              {/* <Image src={checkIcon} alt="checkIcon" className="mt-1 mr-2" /> */}
              <p
                className="family_outfit_regular_400"
                style={
                  index === 0 ? { margin: 0 } : { fontSize: '16px', margin: 0 }
                }
                dangerouslySetInnerHTML={{
                  __html: highlightKeywords(line),
                }}
              />
            </div>
          ) : null
        )}
      </div>
    );
  };

  const paypalOptions = {
    'client-id':
      'AQRvSUPjROQYwZnk-TK9YR4rQ0a1JOyuzuhloudr75QbDKWXnoqH6W7r9z-VaibaogoawEg-1H89-iJ5',
    'disable-funding': 'card',
    currency: 'USD',
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <Row>
            <Col lg={6} className="p-0">
              <div className="pt-10 lg:pt-0">
                <div class="p-16 bg-light-100 border-1 bColor-EFE3D7">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <div>
                      <Image
                        src={ArrowLeftIcon}
                        alt="icon"
                        className="cursor-pointer"
                        onClick={() => navigate(-1)}
                      />
                    </div>
                    <div className="fs-24 family_outfit_semiBold_600 lh-312 fc-292D32 flex items-center">
                      Plans Detail
                    </div>
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Selected Plan :
                    </div>
                    <div className="fs-16 fc-1E1E1E family_outfit_regular_400 lh-30">
                      {loading ? (
                        <Shimmer width="150px" height="20px" />
                      ) : (
                        subscriptionList?.[0]?.name
                      )}
                    </div>
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Selected Plan Type:
                    </div>
                    <div className="fs-16 fc-1E1E1E family_outfit_regular_400 lh-30">
                      {loading ? (
                        <Shimmer width="150px" height="20px" />
                      ) : (
                        subscriptionList?.[0]?.sub_plans?.[0]?.name
                      )}
                    </div>
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Price:
                    </div>

                    {subscriptionList?.[0]?.sub_plans?.[0]?.price ===
                    undefined ? (
                      ''
                    ) : loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <div className="fs-16 fc-1E1E1E family_outfit_regular_400 lh-30">
                        {`$ ${subscriptionList?.[0]?.sub_plans?.[0]?.price}`}
                      </div>
                    )}
                  </Stack>
                  <div className="pt-10 fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                    Description
                  </div>
                  <div className="pt-10">
                    {loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <ProductDescription
                        description={
                          subscriptionList?.[0]?.sub_plans?.[0]?.description
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={6} className="modal-size">
              <div className="pt-10 lg:pt-0">
                <div class="p-16 bg-light-100 border-1 bColor-EFE3D7">
                  <div className="fs-24 family_outfit_semiBold_600 lh-312 fc-292D32 flex items-center border-b bColor-EFE3D7">
                    Checkout
                  </div>
                  <div className="pt-20 flex justify-center fs-20 family_outfit_semiBold_600 lh-312 fc-292D32">
                    Payment Method
                  </div>
                  <div className="pt-20 flex justify-center">
                    <PayPalScriptProvider options={paypalOptions}>
                      <PayPalButtons
                        style={{
                          color: 'white',
                          height: 55,
                        }}
                        onClick={(data, actions) => {
                          if (sandboxLink) {
                            try {
                              // window.open(sandboxLink, '_blank');
                              window.location.href = sandboxLink;
                            } catch (error) {
                              console.error(
                                'Failed to open sandbox link:',
                                error
                              );
                            }
                            return actions.reject();
                          }
                        }}
                        createOrder={(data, actions) => {
                          return actions.order.create({
                            purchase_units: [
                              {
                                amount: {
                                  value:
                                    subscriptionList?.[0]?.sub_plans?.[0]
                                      ?.price,
                                },
                              },
                            ],
                          });
                        }}
                        onError={(err) => {
                          console.error('PayPal script error:', err);
                        }}
                      />
                    </PayPalScriptProvider>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DoctorPaymet;
